import apiClient from "@/axios";

export const getListUsers = async (listId) => {
  const response = apiClient.post("/user/list/access/users-access", {
    listId: listId,
  });
  return response;
};

export const addListAccessToUser = async (
  listId,
  userId,
  sharingPermissionId,
  isNotification
) => {
  const response = apiClient.post("/user/list/access/add", {
    listId: listId,
    userId: userId,
    sharingPermissionId: sharingPermissionId,
    isNotification: isNotification,
  });
  return response;
};

export const removeListAccessFromUser = async (listId, userId) => {
  const response = apiClient.post("/user/list/access/remove", {
    listId: listId,
    userId: userId,
  });
  return response;
}

export const updateNotification = async (listId, userId, isNotification) => {
  const response = apiClient.post("/user/list/access/notification", {
    listId: listId,
    userId: userId,
    isNotification: isNotification,
  });
  return response;
};

export const createList = async (
  name,
  platformTypeId,
  listTypeId,
  isNotification
) => {
  const response = apiClient.post("/user/list/create", {
    listName: name,
    platformTypeId: platformTypeId,
    listTypeId: listTypeId,
    isNotification: isNotification,
  });
  return response;
};

export const updateList = async (listId, name) => {
  const response = apiClient.post("/user/list/update", {
    listId: listId,
    listName: name,
  });
  return response;
};


export const deleteList = async (listId) => {
  const response = apiClient.post("/user/list/delete", {
    listId: listId,
  });
  return response;
};

export const getPlatformList = async (id) => {
  const response = apiClient.post("/user/list/app/platform-lists", {
    platformTypeId: id,
  });
  return response;
};

export const getListByListType = async (id) => {
  const response = apiClient.post("/user/list/list-by-list-type", {
    listTypeId: id,
  });
  return response;
};